import { useParams, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../../component/BreadCrumb';
import InputBox from '../../../../component/InputBox';
import SelectionBox from '../../../../component/SelectionBox';
import BoardPupupCheck from '../../../../component/BoardPupupCheck';
import CodeUtil from '../../../../util/CodeUtil';
import {
    CODE_GROUP_ID,
    COMMUNITY_QNA_ADD_PATH,
    COMMUNITY_QNA_EDIT_PATH,
    COMMUNITY_QNA_PATH,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import TextViewer from '../../../../component/editor/TextViewer';
import CommunityPostEditorInfoBox from '../../../../component/CommunityPostEditorInfoBox';
import CommunityDeleteButtonBox from '../../../../component/buttons/CommunityDeleteButtonBox';
import CommunityEditButtonBox from '../../../../component/buttons/CommunityEditButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../../../component/PopupRef';
import { actionRemove, actionDetail } from '../../../../module/body/community/qna/CommunityQnaModule';
import { VIEW_COMMUNITY_QNA_DETAIL } from '../../../../constant/ViewConstant';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import MultiFileAttachBox from '../../../../component/MultiFileAttachBox';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';

const CommunityQnaDetailView = () => {
    let params = useParams();

    // condition
    const [postingNo, setPostingNo] = useState(params && params.postingNo);
    const [postingTypeCd, setPostingTypeCd] = useState('');
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [answerStatusCd, setAnswerStatusCd] = useState('');
    const [answerUniversityCd, setAnswerUniversityCd] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [files, setFiles] = useState([]);
    const [answerPostingCtnt, setAnswerPostingCtnt] = useState('');
    const [answerFiles, setAnswerFiles] = useState([]);
    const [answerUserNm, setAnswerUserNm] = useState('');
    const [answerUserUniversityNm, setAnswerUserUniversityNm] = useState('');
    const [answerRegDttm, setAnswerRegDttm] = useState('');
    const [deletePemission, setDeletePermission] = useState(false);
    const [askAgainPermission, setAskAgainPermission] = useState(false);
    const [editPermission, setEditPermission] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const popupRef = useRef(null);

    // 최초 초기화 호출
    useEffect(() => {
        window.scrollTo(0, 0);
        initSearch(params.postingNo);
        setFiles([]);
        setAnswerFiles([]);
    }, []);

    const initSearch = (postingNo) => {
        dispatch(
            actionDetail({
                params: { postingNo },
                callback: (result) => {
                    setDetail(result);
                },
            }),
        );
    };

    const setDetail = (result) => {
        setPostingTitleNm(result.postingTitleNm);
        setPostingCtnt(result.postingCtnt);
        setPostingTypeCd(result.postingTypeCd);
        setAnswerStatusCd(result.answerStatusCd);
        setAnswerUniversityCd(result.answerUniversityCd);
        setUserNm(result.userNm);
        setRegDttm(result.regDttm);
        if (NullCheckUtil.isNotEmpty(result.userUniversityCd)) {
            setUniversityNm(
                CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find((el) => el.cd == result.userUniversityCd).cdNm,
            );
        }

        let fileArr = [];
        result.files.forEach((file) => {
            fileArr.push({
                postingNo: file.postingNo,
                fileUid: file.fileUid,
                fileNm: file.fileNm,
                regDttm: file.regDttm,
                noticeTypeCd: file.noticeTypeCd,
            });
        });
        setFiles(fileArr);

        if (AuthenticationUtil.getUserRoleCd() == ROLE.STUDENT && AuthenticationUtil.getUserId() == result.regUserId) {
            setDeletePermission(true);
            setAskAgainPermission(true);
        }

        if (
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
            (AuthenticationUtil.getUserRoleCd() == ROLE.STAFF &&
                AuthenticationUtil.getUserUniversityCd() == result.answerUniversityCd)
        ) {
            setDeletePermission(true);
            setEditPermission(true);
        }

        if (result.answerStatusCd == 'ANSWER') {
            setAnswerPostingCtnt(result.answerPostingCtnt);
            setAnswerUserNm(result.answerUserNm);
            setAnswerRegDttm(result.answerRegDttm);
            if (NullCheckUtil.isNotEmpty(result.answerUserUniversityCd)) {
                setAnswerUserUniversityNm(
                    CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find(
                        (el) => el.cd == result.answerUserUniversityCd,
                    ).cdNm,
                );
            }

            let AnswerFileArr = [];
            result.answerFiles.forEach((file) => {
                AnswerFileArr.push({
                    postingNo: file.postingNo,
                    fileUid: file.fileUid,
                    fileNm: file.fileNm,
                    regDttm: file.regDttm,
                    noticeTypeCd: file.noticeTypeCd,
                });
            });
            setAnswerFiles(AnswerFileArr);
        }
    };

    const handleDelete = () => {
        popupRef.current.openWarning('질의 ' + postingNo + '(를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionRemove({
                        params: { postingNo, questionDelete: true },
                        callback: (pno) => {
                            popupRef.current.openInfo(
                                '게시물 번호 ' + pno + '(가)이 삭제되었습니다. 질의응답 목록으로 이동합니다.',
                                () => {
                                    return function () {
                                        navigate(COMMUNITY_QNA_PATH);
                                    };
                                },
                            );
                        },
                    }),
                );
            };
        });
    };

    const handleAskAgain = () => {
        navigate(COMMUNITY_QNA_ADD_PATH);
    };

    const handleEdit = () => {
        var path = COMMUNITY_QNA_EDIT_PATH + PATH_DELIMITER + postingNo;
        navigate(path);
    };

    const handleConfirm = () => {
        navigate(COMMUNITY_QNA_PATH);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>질의응답</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_QNA_DETAIL.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_QNA_DETAIL.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    <h3 className='cmnty-title faq-tit ico-question'>질의 내용</h3>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                placeholder='제목을 입력하세요.'
                                disabled={true}
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                        <div className='top-box-row divide'>
                            <div className='form-box mr14'>
                                <SelectionBox
                                    title='문의담당 대학'
                                    value={answerUniversityCd}
                                    size='long'
                                    disabled={true}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    useAll={false}
                                    onChange={(e) => setAnswerUniversityCd(e.target.value)}
                                />
                            </div>
                            <div className='form-box form-box-checkbox'>
                                <BoardPupupCheck
                                    title='비밀글 여부'
                                    disabled={true}
                                    checked={postingTypeCd == 'CONFIDENTIAL'}
                                    onChecked={(e) => {
                                        e.target.checked
                                            ? setPostingTypeCd('CONFIDENTIAL')
                                            : setPostingTypeCd('PUBLIC');
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <TextViewer className='cmnty-textarea-box' value={postingCtnt} />
                    <MultiFileAttachBox
                        className='cmnty-file-box'
                        uploadFileHandler={(e) => {}}
                        files={files}
                        editable={false}
                        erasable={false}
                        fileDeleteHandler={(e) => {}}
                    />
                    <CommunityPostEditorInfoBox userNm={userNm} universityNm={universityNm} regDttm={regDttm} />
                    <div className='divider'></div>
                    <div className='answer-wrap'>
                        <h3 className='cmnty-title faq-tit ico-answer'>답변 내용</h3>
                        {answerStatusCd != 'ANSWER' ? (
                            <>
                                <div className='answer-none'>
                                    <span>아직 등록된 답변이 없습니다.</span>
                                </div>
                            </>
                        ) : (
                            <>
                                <TextViewer
                                    className='cmnty-textarea-box'
                                    value={answerStatusCd == 'ANSWER' ? answerPostingCtnt : '답변이 준비중입니다.'}
                                />
                                <MultiFileAttachBox
                                    className='cmnty-file-box'
                                    uploadFileHandler={(e) => {}}
                                    files={answerStatusCd == 'ANSWER' ? answerFiles : []}
                                    editable={false}
                                    erasable={false}
                                    fileDeleteHandler={(e) => {}}
                                />
                                <CommunityPostEditorInfoBox
                                    userNm={answerStatusCd == 'ANSWER' ? answerUserNm : ''}
                                    universityNm={answerStatusCd == 'ANSWER' ? answerUserUniversityNm : ''}
                                    regDttm={answerStatusCd == 'ANSWER' ? answerRegDttm : ''}
                                />
                            </>
                        )}
                    </div>
                    <div className='cmnty-btn-box btn-wrap'>
                        {deletePemission && <CommunityDeleteButtonBox title='삭제' onClick={(e) => handleDelete(e)} />}
                        {askAgainPermission && (
                            <CommunityEditButtonBox title='재질문' onClick={(e) => handleAskAgain(e)} />
                        )}
                        {editPermission && <CommunityEditButtonBox title='편집' onClick={(e) => handleEdit(e)} />}
                        <ConfirmButtonBox title='목록' onClick={(e) => handleConfirm(e)} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityQnaDetailView;
